export const transformRequest = (jsonData = {}) =>
  Object.entries(jsonData)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key as string)}=${encodeURIComponent(
          value as string
        )}`
    )
    .join("&");
